<template>
  <div>
    <!-- <div class="topbar"><span><v-icon size="20" color="white">call</v-icon> (+66)87-463-3368</span></div> -->
    <!-- <v-toolbar color="#ffd600">
            <v-toolbar-title>
                <router-link to="/">
                <img src="@/assets/Pos/weserve-logo.png" alt="weserve-logo" width="200px" style="cursor:pointer;margin-top:8px;">
                </router-link>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            <v-btn @click="toLandingPos()" flat>Point of sale</v-btn>
            <v-btn @click="toLogin()" flat>log in </v-btn>
            </v-toolbar-items>
    </v-toolbar>-->
    <!-- <bannerLoadApp/> -->
    <landingPageApp/>
  </div>
</template>

<script>
// import bannerLoadApp from '../../components/front-web/BannerLoadApp'

import landingPageApp from "@/components/front-web/LandingPageApp";
export default {
  components: {
    // bannerLoadApp,
    landingPageApp
  },
  methods: {
    toLogin() {
      this.$router.push({ path:  "/weserve_admin_login" });
    },
    toLandingPos() {
      this.$router.push({ path: "/landing_pos" });
    }
  }
};
</script>

<style scoped>
.topbar {
  background-color: black;
  height: 30px;
}
.topbar span {
  background-color: black;
  color: white;
  height: 30px;
  padding-top: 3px;
  position: absolute;
  right: 10px;
}

.btn-apple {
  background-color: black;
  width: 230px;
  padding: 7px 0 3px 0;
  border-radius: 6px;
  margin: 10px;
}
.btn-apple:hover {
  background-color: #333;
}
.btn-apple span {
  color: white;
}
.font-apple {
  color: white;
  font-size: 25px;
}
.logo-apple {
  height: 40px;
  margin-top: 8px;
}
.btn-google {
  background-color: black;
  width: 230px;
  padding: 7px 0 3px 0;
  border-radius: 6px;
  margin: 10px;
}
.btn-google:hover {
  background-color: #333;
}
.btn-google span {
  color: white;
}
.font-google {
  color: white;
  font-size: 25px;
}
.logo-google {
  height: 35px;
  margin-top: 10px;
}
</style>
